import { useTranslations } from "next-intl";
import { montserrat } from "utils";

export function FullPaymentPopoverContent() {
  const t = useTranslations();

  const optionClassName = "flex flex-row items-center gap-2";
  return (
    <div className="p-2 rounded-xl max-w-[32rem]">
      <p>{t("Pricing.popover.fullPaymentTopDescription")}</p>
      <ul>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.fullPaymentOptionFirst")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.fullPaymentOptionSecond")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.fullPaymentOptionThird")}
          </span>
        </li>
      </ul>
      <p>{t("Pricing.popover.fullPaymentBottomDescription")}</p>
    </div>
  );
}
